import InputField from "../../applicationUi/components/intake/InputField";
import SelectField from "../../applicationUi/components/intake/SelectField";

const ClientInformationSection = ({ formData, handleChange, isReadOnly = false }) => (
  <div className="space-y-8">
    {/* Client Basic Information */}
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-foreground">Client Information</h3>
        <p className="text-sm text-muted-foreground">
          Enter the client's basic information and contact details.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="First Name"
          name="client.firstName"
          value={formData.client.firstName}
          onChange={handleChange}
          required
      readOnly={isReadOnly}
        />
        <InputField
          label="Last Name"
          name="client.lastName"
          value={formData.client.lastName}
          onChange={handleChange}
          required
      readOnly={isReadOnly}
        />
        <InputField
          label="Email"
          name="client.email"
          value={formData.client.email}
          onChange={handleChange}
          type="email"
          description="Primary contact email for the client"
      readOnly={isReadOnly}
        />
        <SelectField
          label="Gender"
          name="client.gender"
          value={formData.client.gender}
          onChange={handleChange}
          options={[
            { value: "", label: "Select Gender" },
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "transgender", label: "Transgender" },
            { value: "genderqueer", label: "Genderqueer" },
            { value: "non-binary", label: "Non-binary" },
            { value: "agender", label: "Agender" },
            { value: "bigender", label: "Bigender" },
            { value: "other", label: "Other" },
          ]}
      readOnly={isReadOnly}
        />
        <SelectField
          label="Pronouns"
          name="client.pronouns"
          value={formData.client.pronouns}
          onChange={handleChange}
          options={[
            { value: "", label: "Select Pronouns" },
            { value: "he/him", label: "He/Him" },
            { value: "she/her", label: "She/Her" },
            { value: "they/them", label: "They/Them" },
            { value: "xe/xem", label: "Xe/Xem" },
            { value: "ze/zir", label: "Ze/Zir" },
            { value: "other", label: "Other" },
          ]}
      readOnly={isReadOnly}
        />
        <InputField
          label="Date of Birth"
          name="client.dob"
          value={formData.client.dob}
          type="date"
          onChange={handleChange}
          required
      readOnly={isReadOnly}
        />
      </div>
    </div>

    {/* Medical Information */}
    <div className="space-y-4">
      <div className="border-b pb-2">
        <h3 className="text-lg font-semibold">Medical Information</h3>
        <p className="text-sm text-gray-500">
          Provide details about the client's medical contacts and referrals.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="Doctor's Name"
          name="client.doctorName"
          value={formData.client.doctorName}
          onChange={handleChange}
          description="Primary care physician"
      readOnly={isReadOnly}
        />
        <InputField
          label="Doctor's Phone"
          name="client.doctorPhone"
          value={formData.client.doctorPhone}
          onChange={handleChange}
          description="Contact number for the doctor's office"
      readOnly={isReadOnly}
        />
        <InputField
          label="Referral Source"
          name="client.referralSource"
          value={formData.client.referralSource}
          onChange={handleChange}
          description="How did you hear about us?"
      readOnly={isReadOnly}
        />
        <InputField
          label="Referral Reason"
          name="client.referralReason"
          value={formData.client.referralReason}
          onChange={handleChange}
          description="Primary reason for seeking services"
      readOnly={isReadOnly}
        />
      </div>
    </div>

    {/* Address Information */}
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-lg font-semibold text-foreground">Address Information</h3>
        <p className="text-sm text-muted-foreground">
          Enter the client's current residential address.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField
          label="Apartment/Unit"
          name="client.address.aptUnit"
          value={formData.client.address.aptUnit}
          onChange={handleChange}
          description="If applicable"
      readOnly={isReadOnly}
        />
        <div className="grid grid-cols-2 gap-4">
          <InputField
            label="Street Number"
            name="client.address.streetNumber"
            value={formData.client.address.streetNumber}
            onChange={handleChange}
            required
      readOnly={isReadOnly}
          />
          <InputField
            label="Street Name"
            name="client.address.streetName"
            value={formData.client.address.streetName}
            onChange={handleChange}
            required
      readOnly={isReadOnly}
          />
        </div>
        <InputField
          label="City"
          name="client.address.city"
          value={formData.client.address.city}
          onChange={handleChange}
          required
      readOnly={isReadOnly}
        />
        <SelectField
          label="Country"
          name="client.address.country"
          value={formData.client.address.country}
          onChange={handleChange}
          required
          readOnly={isReadOnly}
          options={[
            { value: "", label: "Select Country" },
            { value: "United States", label: "United States" },
            { value: "Canada", label: "Canada" },
          ]}
        />
        <SelectField
          label="State"
          name="client.address.state"
          value={formData.client.address.state}
          onChange={handleChange}
          required
          readOnly={isReadOnly}
          options={formData.client.address.country === "United States" ? [
            { value: "", label: "Select State" },
            { value: "AL", label: "Alabama" },
            { value: "AK", label: "Alaska" },
            { value: "AZ", label: "Arizona" },
            { value: "AR", label: "Arkansas" },
            { value: "CA", label: "California" },
            { value: "CO", label: "Colorado" },
            { value: "CT", label: "Connecticut" },
            { value: "DE", label: "Delaware" },
            { value: "FL", label: "Florida" },
            { value: "GA", label: "Georgia" },
            { value: "HI", label: "Hawaii" },
            { value: "ID", label: "Idaho" },
            { value: "IL", label: "Illinois" },
            { value: "IN", label: "Indiana" },
            { value: "IA", label: "Iowa" },
            { value: "KS", label: "Kansas" },
            { value: "KY", label: "Kentucky" },
            { value: "LA", label: "Louisiana" },
            { value: "ME", label: "Maine" },
            { value: "MD", label: "Maryland" },
            { value: "MA", label: "Massachusetts" },
            { value: "MI", label: "Michigan" },
            { value: "MN", label: "Minnesota" },
            { value: "MS", label: "Mississippi" },
            { value: "MO", label: "Missouri" },
            { value: "MT", label: "Montana" },
            { value: "NE", label: "Nebraska" },
            { value: "NV", label: "Nevada" },
            { value: "NH", label: "New Hampshire" },
            { value: "NJ", label: "New Jersey" },
            { value: "NM", label: "New Mexico" },
            { value: "NY", label: "New York" },
            { value: "NC", label: "North Carolina" },
            { value: "ND", label: "North Dakota" },
            { value: "OH", label: "Ohio" },
            { value: "OK", label: "Oklahoma" },
            { value: "OR", label: "Oregon" },
            { value: "PA", label: "Pennsylvania" },
            { value: "RI", label: "Rhode Island" },
            { value: "SC", label: "South Carolina" },
            { value: "SD", label: "South Dakota" },
            { value: "TN", label: "Tennessee" },
            { value: "TX", label: "Texas" },
            { value: "UT", label: "Utah" },
            { value: "VT", label: "Vermont" },
            { value: "VA", label: "Virginia" },
            { value: "WA", label: "Washington" },
            { value: "WV", label: "West Virginia" },
            { value: "WI", label: "Wisconsin" },
            { value: "WY", label: "Wyoming" },
            { value: "DC", label: "District of Columbia" },
          ] : [
            { value: "", label: "Select State" },
            { value: "AB", label: "Alberta" },
            { value: "BC", label: "British Columbia" },
            { value: "MB", label: "Manitoba" },
            { value: "NB", label: "New Brunswick" },
            { value: "NL", label: "Newfoundland and Labrador" },
            { value: "NS", label: "Nova Scotia" },
            { value: "ON", label: "Ontario" },
            { value: "PE", label: "Prince Edward Island" },
            { value: "QC", label: "Quebec" },
            { value: "SK", label: "Saskatchewan" },
            { value: "NT", label: "Northwest Territories" },
            { value: "NU", label: "Nunavut" },
            { value: "YT", label: "Yukon" },
          ]}
        />
        <InputField
          label="Zip Code"
          name="client.address.zipCode"
          value={formData.client.address.zipCode}
          onChange={handleChange}
          required
          readOnly={isReadOnly}
          placeholder={formData.client.address.country === "United States" ? "12345" : "M5V 3A8"}
        />
      </div>
    </div>
  </div>
);

export default ClientInformationSection;
